import React, { useState } from "react";
import { Container, Row, Col, NavLink, ListGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { images } from "@/constants";
import { getAsset } from "@/helpers/helper";
import BackArrow from "@/components/backArrow";
import ProfileSkeleton from "@/components/common/SkeletonLoader/ProfileSkeleton";
import Timeline from "../../components/Timeline/timeline";
import { useUserProfileState } from "../../hooks/useUserProfileState";
import useIncomingMessageNotice from "@/hooks/useIncomingMessageNotice";
import Coverimg from "./Components/Coverimg/Cover";
import Profileimg from "./Components/Profileimg/profileimg";
import Profiletitle from "./Components/ProfileTitle/profiletitle";
import Profilesection from "./Components/Profile_section_1/Profilesection";
import LinkedInChatDock from "./Components/LinkedInChatDock/LinkedInChatDock";
import "@/style/incomingMessageNotice.css";
import "./userProfile.css";

const Userprofile = (props) => {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isChatMinimized, setIsChatMinimized] = useState(false);

  const handleCardSelect = (businessType) => {
    setSelectedCard(businessType);
  };
  const isMarketerTabActive = selectedCard === "marketerProfile";

  const {
    leftSide,
    rightSide,
    name,
    tabsData,
    activeTab,
    infooo,
    setInfooo,
    location,
    createShop,
    setCreateShop,
    createPost,
    setCreatePost,
    handleTabSelect,
    getActiveTabData,
    inputChange,
    userDatahandler,
    widthHandler,
  } = useUserProfileState({ isMarketerTabActive });

  const { receivedMessageCount, clearReceivedMessageCount } =
    useIncomingMessageNotice({ userId: name?._id, profileId: name?._id });

  // LinkedIn-style messaging dock handlers
  const handleOpenChat = () => {
    clearReceivedMessageCount();
    setIsChatOpen(true);
    setIsChatMinimized(false);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  const handleToggleMinimizeChat = () => {
    setIsChatMinimized((prev) => {
      const next = !prev;
      if (!next) {
        clearReceivedMessageCount();
      }
      return next;
    });
  };

  const handleOpenFullPageChat = () => {
    const targetType = isMarketerTabActive ? "marketer" : "user";
    navigate("/messages", {
      state: {
        returnTo: location.pathname,
        messageProfile: {
          type: targetType,
        },
      },
    });
  };

  if (!infooo) return <ProfileSkeleton />;

  const resolvedAvatar =
    (Array.isArray(infooo?.imageUrl) ? infooo.imageUrl[0] : infooo?.imageUrl)
      ? getAsset(
          Array.isArray(infooo.imageUrl)
            ? infooo.imageUrl[0]
            : infooo.imageUrl,
        )
      : undefined;

  return (
    <>
      <Container className="user-profile-page">
        <Row className="gx-3">
          {leftSide === 7 && rightSide === 5 ? (
            <Col lg={leftSide} sm="12" className="ps-0 pe-0 screenHeight">
              <div className="b-radius border user-profile-left-panel">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <BackArrow back="/SellingSide" mystyle="ps-2 p-1" />
                  <div className="d-flex align-items-center gap-2 ms-auto me-2">
                    {receivedMessageCount > 0 && (
                      <>
                        <NotificationsActiveIcon
                          className="incoming-message-bell text-primary"
                          fontSize="small"
                          aria-hidden="true"
                        />
                        <span className="small fw-semibold text-primary">
                          {receivedMessageCount} message
                          {receivedMessageCount === 1 ? "" : "s"} received
                        </span>
                      </>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={handleOpenChat}
                    >
                      Open chat
                    </button>
                  </div>
                </div>
                <Coverimg
                  widthHandler={widthHandler}
                  inputChange={inputChange}
                  userDatahandler={userDatahandler}
                  setCreateShop={setCreateShop}
                  infooo={infooo}
                  name={name}
                  setInfooo={setInfooo}
                />

                <Profileimg infooo={infooo} name={name} setInfooo={setInfooo} />

                <Profiletitle
                  userDatahandler={userDatahandler}
                  inputChange={inputChange}
                  infooo={infooo}
                  createShop={createShop}
                />

                <div className="bg-vilot">
                  <Profilesection
                    id={infooo?._id || name?._id}
                    userDatahandler={userDatahandler}
                    infooo={infooo}
                    setInfooo={setInfooo}
                    onCardSelect={handleCardSelect}
                  />
                </div>
              </div>
            </Col>
          ) : (
            <Col lg={leftSide === 1 ? 1 : 2} sm="12" className="ps-0 pe-0 screenHeight">
              <div className="miniProfile user-profile-left-panel">
                <div className="Profile-img-mini">
                  <img
                    className="ms-1"
                    src={
                      (
                        Array.isArray(infooo?.imageUrl)
                          ? infooo.imageUrl[0]
                          : infooo?.imageUrl
                      )
                        ? getAsset(
                            Array.isArray(infooo.imageUrl)
                              ? infooo.imageUrl[0]
                              : infooo.imageUrl,
                          )
                        : images.noprofile
                    }
                    alt=""
                    loading="lazy"
                  />
                </div>
                <Col
                  lg="12"
                  md="12"
                  className="d-flex justify-content-between align-items-center mt-2 pe-2"
                >
                  <div>
                    <h4 className="ms-3">
                      {infooo?.fullname || name?.fullname}
                    </h4>
                    <h5 className="ms-3" style={{ fontSize: "12px" }}>
                      <p>
                        {typeof infooo?.description === "string"
                          ? infooo.description
                          : infooo?.description?.text}
                      </p>
                    </h5>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary-mini btn-sm font_small_profile px-2 py-1"
                    onClick={handleOpenChat}
                    title="Open chat"
                  >
                    Chat
                  </button>
                </Col>
                <div className="bg-vilot">
                  <div>
                    <div className=" bg-white pr-0 mt-2 ">
                      <h6>Profile Introduction</h6>
                      <ListGroup
                        className={`introBox list-unstyled font_small_profile ${
                          leftSide === 1 ? "lessWidthData" : ""
                        }`}
                      >
                        <ListGroup.Item className="d-flex ms-3 border-0 p-1 ">
                          <div>{name?.address?.text}</div>
                        </ListGroup.Item>
                        {infooo?.education?.map((item, index) => (
                          <ListGroup.Item
                            key={index}
                            className="d-flex ms-3 border-0 p-1"
                          >
                            <div>{item?.text}</div>
                          </ListGroup.Item>
                        ))}

                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          <div>{infooo?.contactNumber?.text}</div>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          <div> {infooo?.email}</div>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          <div> {infooo?.createdAt?.slice(0, 10)}</div>
                        </ListGroup.Item>
                      </ListGroup>
                      {location.pathname === "/user-profile" ? (
                        <Col lg="12">
                          <NavLink to="/user-cv-form">
                            <div className="d-flex justify-content-center">
                              <Button
                                type="button"
                                className="btn ms-1 py-2 px-2 btn-primary-mini font_small_profile mb-4 mt-4"
                              >
                                Create Cv
                              </Button>
                            </div>
                          </NavLink>
                        </Col>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}

          {/* Right side content side */}
          <Col
            lg={rightSide}
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div className="border b-radius user-profile-timeline-panel">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={(getActiveTabData() || []).slice().sort((a, b) => {
                  const dateA = new Date(a.createdAt || 0);
                  const dateB = new Date(b.createdAt || 0);
                  return dateB - dateA;
                })}
                loading={false}
                createPost={createPost}
                setCreatePost={setCreatePost}
                mybusinessType={createPost?.businessType}
                tabTitleOverrides={{
                  foodShop: "Food Service Timeline",
                  retailerShop: "Retail Timeline",
                  wholesellerShop: "Wholeseller Timeline",
                  rawmaterialShop: "Rawmaterial Timeline",
                  gemShop: "Gems & Jewelry Timeline",
                  homemadeShop: "Homemade Timeline",
                  businessPropertyCompany: "Business Property Timeline",
                  usedVehicleShop: "Used Vechile Timeline",
                  transportShop: "Transportation Timeline",
                  recycledShop: "Recycled Material Timeline",
                  services: "Service's Timeline",
                  farmingShop: "Farming Market Timeline",
                  manufacturerShop: "Manufacturer Timeline",
                  jobsCompany: "Job Offer Timeline",
                  usedShop: "2nd Hand item Timeline",
                }}
                rightSide={rightSide}
              />
            </div>
          </Col>
        </Row>
      </Container>

      {/* LinkedIn-style Messaging Dock (bottom side to top) */}
      <LinkedInChatDock
        isOpen={isChatOpen}
        onClose={handleCloseChat}
        isMinimized={isChatMinimized}
        onToggleMinimize={handleToggleMinimizeChat}
        initialProfile={{ type: isMarketerTabActive ? "marketer" : "user" }}
        userName={infooo?.fullname || name?.fullname || "User"}
        userAvatar={resolvedAvatar}
        unreadCount={receivedMessageCount}
        onClearUnread={clearReceivedMessageCount}
        onOpenFullPage={handleOpenFullPageChat}
      />
    </>
  );
};

export default Userprofile;
